import { useSelector } from 'react-redux';

import { getConfig } from '@edx/frontend-platform';
import { useIntl, FormattedMessage } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

import { RegisterCompletionSVG } from '../../assets/svgs';
import FieldRenderer from '../../field-renderer/FieldRenderer';
import { frameSafeRedirect } from '../data/utils';
import useMarketingPreference from '../hooks/useMarketingPreference';
import messages from '../messages';

const RegistrationProcessCompletion = ({ 
  queryParams, 
  formFields 
}) => {
  const { authenticatedUser } = useSelector(state => state.commonComponents);

  const { formatMessage } = useIntl();

  const isNextParam = queryParams.next && queryParams.next !== '/';
  const linkDestination = isNextParam ? queryParams.next : getConfig().CAMPUS_LOGO_URL;
  const linkDestinationForWP = isNextParam ? getConfig().LMS_BASE_URL+'/register?next='+queryParams.next : getConfig().LMS_BASE_URL+'/';


  const linkMessage = isNextParam
    ? formatMessage(messages['registration.process.completion.page.button.course'])
    : formatMessage(messages['registration.process.completion.page.button.catalog']);

  const { isMarketable, handleChange } = useMarketingPreference();

  return (
    <div className="registration-process-completion d-flex justify-content-center flex-fill" data-gtm="registration_additional_data_process_completion">
      <div className="content-wrapper flex-center-column">
        <h1 className="page-title">
          {formatMessage(messages['registration.process.completion.page.title'], { fullName: formFields?.full_name || authenticatedUser?.username || '' })}
        </h1>
        <div className='mx-3'>
          <p className="regular-text text-start mx-1">
            <FormattedMessage {...messages['registration.process.completion.page.subtitle']} values={{ enter: <br /> }} />
          </p>
          <p className="my-3 font-weight-bold mx-1">
            <FormattedMessage {...messages['registration.process.completion.page.support.text']} values={{ enter: <br /> }} />
          </p>
          <FieldRenderer
            className="cursor-pointer"
            value={isMarketable}
            fieldData={{ type: 'checkbox', label: formatMessage(messages['accept.recieving.courses.and.projects.updates']) }}
            onChangeHandler={handleChange}
          />
        </div>
        <div className='mt-5'>
          <button
            type="button"
            className="logistration-btn"
            onClick={() => frameSafeRedirect(linkDestinationForWP)}
          >
            {linkMessage}
          </button>
        </div>
        <img className='mt-5' src={RegisterCompletionSVG} alt="register-completion" />
      </div>
    </div>
  );
};

RegistrationProcessCompletion.propTypes = {
  queryParams: PropTypes.shape({ next: PropTypes.string }).isRequired,
};

export default RegistrationProcessCompletion;
